import React, { useEffect, useState } from "react";
import { Button, Message, Input } from "../../../BP2Components";
import IntlMessages from "@util/IntlMessages";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { addBoard } from "../../../../services/restAPI/RestApi";
import {
   updateBoards,
   updateTranslationsUsage,
   syncBoardTranslationsToService,
} from "@util/Scripts";
import "./AddBoardPanel.less";

const AddBoardPanel = () => {
   const intl = useIntl();
   const [isOpen, setIsOpen] = useState(false);
   const [boardNames, setBoardNames] = useState({});

   const { allLanguages } = useSelector(({ settings }) => settings);

   const handleAddBoard = (name) => async () => {
      try {
         if (!name) {
            Message.error(intl.formatMessage({ id: "global.noNameProvided" }));
            return;
         }

         Message.loading(intl.formatMessage({ id: "global.loading" }), 0);
         const res = await addBoard(name);
         await syncBoardTranslationsToService(res.data?.translations, allLanguages);
         setIsOpen(false);
         updateTranslationsUsage(intl, true);
         updateBoards(intl);
      } catch (err) {
         Message.destroy();
         Message.error(intl.formatMessage({ id: "global.error" }));
      }
   };

   const handleNameChange =
      (language) =>
      ({ target }) =>
         setBoardNames((prevNames) => ({ ...prevNames, [language]: target.value }));

   useEffect(() => {
      const close = ({ target }) => {
         if (!document.querySelector("#add-board-panel")?.contains(target)) {
            setIsOpen(false);
         }
      };
      window.addEventListener("click", (e) => close(e));
      return window.removeEventListener("click", (e) => close(e));
   }, []);

   return (
      <div className="add-board" id="add-board-panel">
         <Button
            htmlType="button"
            onClick={() => setIsOpen((prevOpen) => !prevOpen)}
            id="add-board-modal"
         >
            <IntlMessages id="global.addBoard" />
         </Button>
         {isOpen && (
            <div className="add-board__panel">
               <IntlMessages id="global.addBoard" />
               {allLanguages?.map(({ language }) => (
                  <Input
                     id={`${language}-input`}
                     key={language}
                     addonBefore={language.toUpperCase()}
                     onChange={handleNameChange(language)}
                     onPressEnter={handleAddBoard(boardNames)}
                     style={{ color: "black" }}
                  />
               ))}
               <Button
                  htmlType="button"
                  style={{ backgroundColor: "white" }}
                  onClick={handleAddBoard(boardNames)}
                  id="add-board-btn"
               >
                  <IntlMessages id="global.add" />
               </Button>
            </div>
         )}
      </div>
   );
};

export default AddBoardPanel;
